import React, {useContext} from 'react';
import './ProfileDisounts.less';
import {ProfilePicker} from "compositions/profile-picker/ProfilePicker";
import {ProfilePickerTrigger} from "elements/profile-picker-trigger/ProfilePickerTrigger";
import {List} from "elements/list/List.tsx";
import {ListItem} from "elements/list-item/ListItem.tsx";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const ProfileDiscounts = ({
																	 isShowCashpoints,
																	 cashpointsAmount,
																	 cashpointsName,
																	 onCashpointsClick,
																	 isShowOffers,
																	 offersCount,
																	 onOffersClick

																 }) => {
	const translations = useContext(TranslationsContext);

	return <List>
		{
			isShowCashpoints && (
				<ListItem key="cashpoints" onClick={onCashpointsClick} isResponsive>
					<ProfilePicker title={cashpointsName}>
						<ProfilePickerTrigger text={cashpointsAmount}/>
					</ProfilePicker>
				</ListItem>
			)
		}
		{
			isShowOffers && (
				<ListItem key="offers" onClick={onOffersClick} isResponsive>
					<ProfilePicker title={getSafeTranslation('ProfileDiscounts.offersLabel', translations)}>
						<ProfilePickerTrigger
							text={getSafeTranslation('ProfileDiscounts.offersValue', translations).replace('{count}', offersCount)}/>
					</ProfilePicker>
				</ListItem>
			)
		}
	</List>
}
